import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { getWindowOrigin } from "@helper/utils";

export const URL_ORIGIN = "https://www.tabla.com.sg/";
export const OG_SITE_NAME = "Tabla";
export const ROBOTS =
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
export const OG_IMAGE = "/web2-assets/tabla_default.png";

export const FB_APP_ID = "276165649676865";

export const LOCALHOST = "http://localhost";

export const DEFAULT_OG_IMAGE_WIDTH = 1200;
export const DEFAULT_OG_IMAGE_HEIGHT = 630;

const windowOrigin = removeTrailingSlash(getWindowOrigin());
const ogImage = (fileName: string) =>
  `${windowOrigin}/web2-assets/ogImages/${fileName}.png`;

// Keys are the section slugs in `TABLA_SECTIONS` plus the `/quick-news` route.
// Sub-sections resolve to their parent section via `getSectionOgImageUrl`.
export const sectionOgImageUrl = {
  community: ogImage("community"),
  culture: ogImage("culture"),
  default: ogImage("default"),
  lifestyle: ogImage("lifestyle"),
  news: ogImage("news"),
  "quick-news": ogImage("quick-news"),
};

export type SectionOgImageKey = keyof typeof sectionOgImageUrl;

const toOgImageKey = (name?: string | null) =>
  name?.trim().toLowerCase().replace(/\s+/g, "-");

/**
 * Resolves the section OG image, trying each name in order (e.g. section name
 * first, then its parent section) and falling back to the default image.
 */
export const getSectionOgImageUrl = (
  ...sectionNames: (string | null | undefined)[]
) => {
  for (const sectionName of sectionNames) {
    const key = toOgImageKey(sectionName);
    if (key && Object.hasOwn(sectionOgImageUrl, key)) {
      return sectionOgImageUrl[key as SectionOgImageKey];
    }
  }

  return sectionOgImageUrl.default;
};
